import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/index';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = false;

  constructor(private router: Router) {
    // clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next();
        }
      }
    });
  }

  /**
   * @description Based on the input it will show the success message.
   * @param {string} message
   * @param {boolean} [keepAfterNavigationChange=false]
   * @memberof AlertService
   */
  success(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'success', text: message });
  }

  /**
   * @description Based on the input it will show the error message.
   * @param {string} message
   * @param {boolean} [keepAfterNavigationChange=false]
   * @memberof AlertService
   */
  error(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'error', text: message });
  }

  /**
   * @description Based on the input it will remove the message.
   * @param {string} message
   * @param {boolean} [keepAfterNavigationChange=false]
   * @memberof AlertService
   */
  remove(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({});
  }

  /**
   * @description Based on the input it will get the message.
   * @returns {Observable<any>}
   * @memberof AlertService
   */
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
